import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/images/三维视频封面.jpg';
const _withScopeId = n => (_pushScopeId("data-v-6f89a1ab"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "product-details flex-col"
};
const _hoisted_2 = {
  class: "common-dark"
};
const _hoisted_3 = {
  class: "path main-content"
};
const _hoisted_4 = {
  class: "router-path"
};
const _hoisted_5 = {
  class: "common-dark"
};
const _hoisted_6 = {
  class: "main-content content flex-row"
};
const _hoisted_7 = {
  class: "flex-col gap10"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "chevron left"
}, null, -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "chevron right"
}, null, -1));
const _hoisted_10 = [_hoisted_8, _hoisted_9];
const _hoisted_11 = {
  key: 0,
  class: "circle-content flex-row-center"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  class: "group flex-col flex-full"
};
const _hoisted_14 = {
  class: "title"
};
const _hoisted_15 = {
  class: "contact"
};
const _hoisted_16 = {
  class: "common-dark"
};
const _hoisted_17 = {
  class: "main-content flex-col"
};
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  class: "common-dark grey"
};
const _hoisted_20 = {
  class: "common-title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RouterLink = _resolveComponent("RouterLink");
  const _component_DesItem = _resolveComponent("DesItem");
  const _component_ProductScroll = _resolveComponent("ProductScroll");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_RouterLink, {
    to: "/"
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('home')), 1)]),
    _: 1
  }), _createTextVNode(" > "), _createVNode(_component_RouterLink, {
    to: '/class/' + _ctx.className
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t(_ctx.className + '.name')), 1)]),
    _: 1
  }, 8, ["to"]), _createTextVNode(" > "), _createElementVNode("span", null, _toDisplayString(_ctx.$t(_ctx.styles.title)), 1)])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
    class: "product-img flex-col imgbg-contain",
    style: _normalizeStyle('background-image: url(' + _ctx.imgUrl + ');')
  }, _hoisted_10, 4), _ctx.styles.style && _ctx.styles.style.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.styles.style, (item, i) => {
    return _openBlock(), _createElementBlock("div", {
      class: "circle",
      key: i,
      style: _normalizeStyle('background-color: ' + item.color),
      onClick: $event => _ctx.imgUrl = _ctx.baseUrl + item.img
    }, null, 12, _hoisted_12);
  }), 128))])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t(_ctx.styles.title)), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.styles.description, (item, i) => {
    return _openBlock(), _createBlock(_component_DesItem, {
      key: i,
      data: item,
      islast: i == _ctx.styles.description.length - 1
    }, null, 8, ["data", "islast"]);
  }), 128)), _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('contact')), 1)])])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_ctx.styles.video ? (_openBlock(), _createElementBlock("video", {
    key: 0,
    src: _ctx.styles.video,
    autoplay: "",
    controls: "",
    poster: _imports_0
  }, null, 8, _hoisted_18)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('qlabel11')), 1), _createVNode(_component_ProductScroll, {
    class: "main-content",
    list: _ctx.list.list,
    "product-class": _ctx.className
  }, null, 8, ["list", "product-class"])])]);
}